module.exports = __webpack_public_path__ + "img/postgresql.9623d4d4.png";